import { AssignConversationRequest, AssignConversationToQueueRequest, ConversationSummarySchema, QueueCreate, QueueListResponse, QueueSummarySchema, QueueUpdate, } from '@aeris/contracts';
import { request } from "./client.js";
/**
 * `/api/v1/communication/queues` — as filas, e a quem cada conversa pertence
 * (F047).
 *
 * O CRUD de filas e membros está atrás de
 * `communication.queue.read`/`.write` — administração, não atendimento. Já
 * `assignConversationToQueue` e `assignConversation` são o gesto do dia a dia,
 * e por isso ficam aqui junto: um 403 em `assignConversation` é o servidor
 * recusando TOMAR de outra pessoa sem a permissão.
 */
/** Move a conversa para uma fila, ou tira dela com `queueId: null` (F047). */
export const assignConversationToQueue = async (conversationId, input) => ConversationSummarySchema.parse(await request(`/api/v1/communication/conversations/${conversationId}/queue`, {
    method: 'POST',
    body: AssignConversationToQueueRequest.parse(input),
}));
/**
 * Atribui a conversa, assume ("é minha") ou tira o responsável — F047.
 *
 * Um 403 aqui é o servidor recusando TOMAR de outra pessoa sem a permissão
 * (`canAssignConversation`, `@aeris/communication`) — a tela deixa o
 * `ApiError` subir para quem chamou decidir como mostrar.
 */
export const assignConversation = async (conversationId, input) => ConversationSummarySchema.parse(await request(`/api/v1/communication/conversations/${conversationId}/assign`, {
    method: 'POST',
    body: AssignConversationRequest.parse(input),
}));
export const fetchQueues = async (signal) => QueueListResponse.parse(await request('/api/v1/communication/queues', { signal })).queues;
export const createQueue = async (input) => QueueSummarySchema.parse(await request('/api/v1/communication/queues', {
    method: 'POST',
    body: QueueCreate.parse(input),
}));
export const updateQueue = async (id, input) => QueueSummarySchema.parse(await request(`/api/v1/communication/queues/${id}`, {
    method: 'PATCH',
    body: QueueUpdate.parse(input),
}));
export const addQueueMember = async (queueId, input) => QueueSummarySchema.parse(await request(`/api/v1/communication/queues/${queueId}/members`, {
    method: 'POST',
    body: input,
}));
export const removeQueueMember = async (queueId, employeeId) => QueueSummarySchema.parse(await request(`/api/v1/communication/queues/${queueId}/members/${employeeId}`, { method: 'DELETE' }));
//# sourceMappingURL=communication-queues.js.map